<template>
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start',
    ]"
    v-if="this.$store.state.showSidenav && is_verified"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
    :style="this.$store.state.isRTL ? 'overflow-x: hidden' : ''"
  >
    <!-- nav -->
    <navbar
      :class="[navClasses]"
      :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="navbarMinimize"
      v-if="this.$store.state.showNavbar && $route.path !== '/sign-in'"
    />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />
    <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : '',
      ]"
    />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import { generalApiRequest } from "./api/apiIndex";
import { getTokenRemainingTime } from "./t_js_resources/token_decode";
export default {
  name: "App",
  data() {
    return {
      is_verified: true,
      threshold_time: 30,
    };
  },
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter,
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    async immediate_action() {
      var token_time_to_expiry = getTokenRemainingTime(
        this.$store.getters.getTokenGenerationTime
      );

      if (token_time_to_expiry < 31) {
        const res = await generalApiRequest("renew_auth_token", "post", {}, 1);
        var new_tok = res.data;
        var new_time = res.ttime;
        this.$store.dispatch("updateToken", new_tok);
        this.$store.dispatch("updateTime", new_time);
      }
    },
    // async startLogCalculator() {
    //   // -----------------------------------------------------------

    //   setInterval(async () => {
    //     var lapsed_time = this.getMinutesElapsed(
    //       this.$store.getters.getLastActivityTime
    //     );
    //     // console.log(lapsed_time + " - is the lapsed time");
    //     var is_active = lapsed_time < this.threshold_time ? true : false;
    //     var token_life_is_deminishing =
    //       getTokenRemainingTime(this.$store.getters.getTokenGenerationTime) <
    //       this.threshold_time
    //         ? true
    //         : false;
    //     if (is_active && token_life_is_deminishing) {
    //       const res = await generalApiRequest(
    //         "renew_auth_token",
    //         "post",
    //         {},
    //         1
    //       );
    //       var new_tok = res.data;
    //       var new_time = res.ttime;
    //       this.$store.dispatch("updateToken", new_tok);
    //       this.$store.dispatch("updateTime", new_time);
    //     }

    //     //
    //   }, 30 * 60 * 1000); //30 minutes
    // },

    getMinutesElapsed(lastActivityTime) {
      if (lastActivityTime != "") {
        const now = new Date();
        const lastTime = new Date(lastActivityTime);
        const diffMs = now - lastTime; // difference in milliseconds

        const minutes = Math.floor(diffMs / (1000 * 60));
        return minutes;
      } else {
        return 0;
      }
    },
  },
  computed: {
    navClasses() {
      return {
        "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky": this
          .$store.state.isNavFixed,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
      };
    },
  },
  beforeMount() {
    // console.log("this is a crazy err");

    this.$store.state.isTransparent = "bg-transparent";

    if (this.$store.getters.isAuthenticated) {
      this.is_verified = true;
    } else {
      this.is_verified = false;
    }
  },
  // for inactivity timer
  mounted() {
    // if (this.$store.getters.isAuthenticated) {
    //   this.$store.dispatch("startInactivityWatcher");
    // }
    // track activity
    this.immediate_action();
    // this.startLogCalculator();
  },
  // beforeUnmount() {
  //   this.$store.dispatch("clearInactivityWatcher");
  // },
};
</script>
